import { VFC } from 'react';
import { useHistory } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';

import { Typography } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';

export const Breadcrumb: VFC<{
  folderPath: string;
  name: string;
  rootPath: string;
  moveCopyView?: boolean;
  onSelect?: (path: string) => void;
}> = ({ folderPath, name, rootPath, moveCopyView, onSelect }) => {
  const history = useHistory();
  const crumbs = folderPath.split('/').filter((c) => c.length > 0);
  return (
    <>
      <Typography
        style={{ cursor: 'pointer' }}
        onClick={() => {
          if (moveCopyView) {
            onSelect?.('');
            return;
          }
          history.push(rootPath);
        }}
      >
        {name}
      </Typography>

      {crumbs.map((c, i) => (
        <Fragment key={i}>
          <ChevronRight />
          <Typography
            style={{ marginLeft: '0px', cursor: 'pointer' }}
            onClick={() => {
              if (moveCopyView) {
                onSelect?.(crumbs.slice(0, i + 1).join('/'));
                return;
              }

              history.push(`${rootPath}/${crumbs.slice(0, i + 1).join('/')}`);
            }}
          >
            {c}
          </Typography>
        </Fragment>
      ))}
    </>
  );
};
